import { render, staticRenderFns } from "./OrderScheduleMealTable.vue?vue&type=template&id=379852ee&scoped=true"
import script from "./OrderScheduleMealTable.vue?vue&type=script&lang=js"
export * from "./OrderScheduleMealTable.vue?vue&type=script&lang=js"
import style0 from "./OrderScheduleMealTable.vue?vue&type=style&index=0&id=379852ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379852ee",
  null
  
)

export default component.exports